"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AntdSelectUtils = void 0;
var getFilterByLabel = function () {
    return function (queryVal, option) {
        var _a;
        if (!queryVal)
            return true;
        /* We are enabling search by label and not by value */
        /* Because the values are ids and it's not good UX */
        return (((_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(queryVal.toLowerCase())) || false);
    };
};
exports.AntdSelectUtils = {
    getFilterByLabel: getFilterByLabel,
};
